import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {CalculationGoldListElement} from './calculation-gold.models';
import {queryKey} from './calculation-gold-querykeys';

interface Props {
  selected: CalculationGoldListElement;
}
export function useCalculationGoldDeleteMutation(props: Props): {mutate: () => void} {
  const queryClient = useQueryClient();
  const {mutate} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.delete(`${environment.apiv4uri}calculation/gold/${props.selected.id}`),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKey.list()});
    },
  });

  return {mutate: () => mutate()};
}
